export default __webpack_public_path__ + "static/media/timeless-industry.b9c4eafa.jpg";